import UibookCase from 'uibook/case'
import React from 'react'
import AiSettingsPopup from '../AiSettingsPopup'

const ACTIONS = {
  onCancel: UibookCase.event('onAiPopupCancel'),
  onReset: UibookCase.event('onAiPopupReset'),
  onSave: UibookCase.event('onAiPopupSave'),
  onMemoryClick: UibookCase.event('onAiPopupCapabilityMemoryClick'),
  onToolsClick: UibookCase.event('onAiPopupCapabilityToolsClick'),
  onWebClick: UibookCase.event('onAiPopupCapabilityWebClick')
}

const COMMENTS = {
  baseline: 'Baseline configuration with no safety banner shown.',
  banner: 'Informational warning banner with editable settings still available.',
  constrained: 'Constrained profile with external tools disabled and clear warning.',
  lockdown: 'Hard lockdown state combining warning banner and read-only controls.'
}

export default {
  background: 'dark',
  component: AiSettingsPopup,
  i18n: true,
  cases: [
    () => <UibookCase props={{
      ...ACTIONS,
      popupState: 'draft',
      model: 'balanced',
      memoryEnabled: true,
      toolsEnabled: true,
      webEnabled: true,
      showSafetyWarning: false,
      description: COMMENTS.baseline
    }}></UibookCase>,
    () => <UibookCase props={{
      ...ACTIONS,
      popupState: 'draft',
      model: 'balanced',
      memoryEnabled: true,
      toolsEnabled: true,
      webEnabled: true,
      showSafetyWarning: true,
      note: 'Policy advisory enabled for operations with elevated impact.',
      description: COMMENTS.banner
    }}></UibookCase>,
    () => <UibookCase props={{
      ...ACTIONS,
      popupState: 'draft',
      model: 'fast',
      memoryEnabled: false,
      toolsEnabled: false,
      webEnabled: false,
      showSafetyWarning: true,
      note: 'External capabilities disabled by organizational compliance policy.',
      description: COMMENTS.constrained
    }}></UibookCase>,
    () => <UibookCase props={{
      ...ACTIONS,
      popupState: 'restricted',
      model: 'fast',
      memoryEnabled: false,
      toolsEnabled: false,
      webEnabled: false,
      showSafetyWarning: true,
      note: 'Administrative lock: only inspection is allowed in this context.',
      description: COMMENTS.lockdown
    }}></UibookCase>
  ]
}
